const cards = document.querySelectorAll('.js-team-card');

cards.forEach((card) => {
  card.addEventListener('click', () => {
    card.classList.toggle('is-open');
  });

  card.querySelectorAll('.team__card-social').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
});
